import { Schema as S } from "effect";

const KimAccountSchema = S.Struct({
  kimUsername: S.String,
  authorisedUsers: S.optional(S.Array(S.String)),
  iccsn: S.optional(S.String),
  tiContext: S.String,
  loginStatus: S.optional(S.String),
  serverAddressPOP: S.optional(S.String),
  serverAddressSMTP: S.optional(S.String),
  popUserId: S.optional(S.String),
  smtpUserId: S.optional(S.String),
  serverAddressSpecialService: S.optional(S.String),
  connectorId: S.optional(S.String),
});

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const GetKimAccountsResponseSchema = S.Array(KimAccountSchema);

export type GetKimAccountsResponse = S.Schema.Type<typeof GetKimAccountsResponseSchema>;
